import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoginBannerImage1 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 82,
	height: 80,
	viewBox: "0 0 82 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame 2147224442",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M44.1394 44.8619C52.457 49.9656 63.4832 48.9154 70.6854 41.7132C73.7185 38.6782 75.6603 34.968 76.5128 31.0657C78.0256 24.1228 76.0838 16.5774 70.6854 11.1771C62.254 2.74565 48.5827 2.74565 40.1512 11.1771C32.4062 18.924 31.7757 31.0899 38.2597 39.5549L25.3775 52.4353L22.7809 49.8387L0.999023 71.6206L8.38028 79L30.1603 57.22L27.4014 54.4611L35.4132 46.4493L37.2263 44.6362C47.2396 54.6495 63.4739 54.6495 73.4891 44.6362C83.5023 34.6229 83.5023 18.3886 73.4891 8.37533C63.4739 -1.63796 47.2396 -1.63796 37.2263 8.37533C29.7238 15.8778 27.8435 26.8723 31.5817 36.1264C32.0163 37.2009 32.5256 38.2492 33.1095 39.2677",
				stroke: "white",
				strokeWidth: 1.29456
			})
		}), /* @__PURE__ */ _jsx("g", {
			id: "Group_2",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M71.747 31.0913C72.9781 25.4486 71.4 19.3152 67.0127 14.9298",
				stroke: "white",
				strokeWidth: 1.29456
			})
		})]
	})
});
export default SvgLoginBannerImage1;
